/* src/components/Why/Why.jsx */
import './Why.css'
import {usePanelStatus} from "../HorizontalScroll/panelStatus.js";

// статус панелі з контексту → клас-фаза інтро
const STATUS_CLASS = {
	after: 'is-armed',   // ще не дійшли: елементи на стартових позиціях, сховані
	active: 'is-in',     // доведена: заходять етапами
	before: 'is-out',    // пройшли далі: усе роз'їжджається назад
	static: null,        // без горизонтального скролу: просто показуємо контент
};

const Why = () => {
	const status = usePanelStatus();
	const classes = ['why', STATUS_CLASS[status]].filter(Boolean).join(' ');

	return (
		<section className={classes} id="why">
			<div className="why__container">
				<div className="why__text">
					<h2 className='why__title'>Чому Avenue</h2>
					<ul className='why__list'>
						<li className='why__list-item'>
							<h5>Довговічна</h5>
							<span>Бо матеріали із власних родовищ і контроль на кожному етапі виробництва, що гарантує міцність продукції на роки </span>
						</li>
						<li className='why__list-item'>
							<h5>Різноманітна </h5>
							<span>Широка лінійка колекцій для будь-якого масштабу: від приватного подвір'я до міського кварталу </span>
						</li>
						<li className='why__list-item'>
							<h5>Від "Ковальської"</h5>
							<span>Контроль сировинної бази, внутрішня логістика, гарантія компанії. Ви маєте справу безпосередньо з виробником</span>
						</li>
					</ul>
				</div>

				<img className="why__img why__img-desktop" src='/images/why.webp' alt='Why' />
				<img className="why__img why__img-mobile" src='/images/why_mob.webp' alt='Why' />
			</div>
		</section>
	);
};

export default Why;